import { render, staticRenderFns } from "./LoadOrderCreate.vue?vue&type=template&id=6b3b0872&scoped=true&"
import script from "./LoadOrderCreate.vue?vue&type=script&lang=js&"
export * from "./LoadOrderCreate.vue?vue&type=script&lang=js&"
import style0 from "./LoadOrderCreate.vue?vue&type=style&index=0&id=6b3b0872&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b0872",
  null
  
)

export default component.exports